import React from "react";
import NotFound from "./NotFound";

function Instructions() {
  return (
    <div className="unloadPage">
      <NotFound />
    </div>
  );
}

export default Instructions;
